import {
  AlertCircle as AlertCircleIcon,
  AlertOctagon as AlertOctagonIcon,
  AlertTriangle as AlertTriangleIcon,
} from 'react-feather'

const RISK = { low: 'Baixo', medium: 'Médio', high: 'Alto' }

const RISK_OPTIONS = Object.entries(RISK).map(([value, label]) => ({
  id: value,
  name: label,
}))

const RISK_CHIP_COLORS = { low: 'low', medium: 'medium', high: 'high' }

const RISK_ALERTS = {
  low: {
    label: 'BAIXO',
    description:
      'Esta Inteligência Artificial não processa dados pessoais. Mantenha o monitoramento sobre mudanças no escopo de uso e nas finalidades para garantir que o risco permaneça controlado.',
  },
  medium: {
    label: 'MÉDIO',
    description:
      'Esta Inteligência Artificial processa dados pessoais. Adote medidas de segurança proporcionais, mantenha registros das finalidades e realize avaliações periódicas de impacto.',
  },
  high: {
    label: 'ALTO',
    description:
      'Esta Inteligência Artificial apresenta riscos elevados ao tratamento de dados pessoais. É recomendada revisão imediata, restrição do uso ou descontinuação até que medidas de mitigação sejam implementadas.',
  },
}

const AI_INVENTORY_FORM_DRIVER_STEP_1 = 'ai-inventory-form-step-1'
const AI_INVENTORY_FORM_DRIVER_STEP_2 = 'ai-inventory-form-step-2'
const AI_INVENTORY_FORM_DRIVER_STEP_3 = 'ai-inventory-form-step-3'
const AI_INVENTORY_FORM_DRIVER_STEP_4 = 'ai-inventory-form-step-4'
const AI_INVENTORY_FORM_DRIVER_STEP_5 = 'ai-inventory-form-step-5'
const AI_INVENTORY_FORM_DRIVER_STEP_6 = 'ai-inventory-form-step-6'
const AI_INVENTORY_FORM_DRIVER_STEP_7 = 'ai-inventory-form-step-7'

const AI_INVENTORY_FORM_DRIVER_STEPS = [
  {
    element: '#' + AI_INVENTORY_FORM_DRIVER_STEP_1,
    popover: {
      title: 'Tutorial do Formulário',
      description:
        'Bem-vindo ao <strong>cadastro manual</strong> de Inventário de IA! Se preferir um caminho mais rápido, você também pode cadastrar de forma <strong>guiada pela DAI</strong>. Use este tutorial sempre que precisar de ajuda para preencher o formulário.',
    },
  },
  {
    element: '#' + AI_INVENTORY_FORM_DRIVER_STEP_2,
    popover: {
      title: 'Etapas do Formulário',
      description:
        'O formulário é dividido em <strong>4 etapas</strong>. Clique em qualquer aba para navegar entre elas a qualquer momento.',
    },
  },
  {
    element: '#' + AI_INVENTORY_FORM_DRIVER_STEP_3,
    popover: {
      title: 'Etapa 1 — Informações Gerais',
      description:
        'Selecione qual <strong>Inteligência Artificial</strong> sua empresa utiliza e informe os <strong>departamentos</strong> onde ela é usada. Caso a IA não esteja na lista, escolha <strong>Outro</strong> para cadastrá-la manualmente.',
    },
  },
  {
    element: '#' + AI_INVENTORY_FORM_DRIVER_STEP_4,
    popover: {
      title: 'Etapa 2 — Finalidade',
      description:
        'Registre <strong>para qual propósito</strong> a IA é utilizada — por exemplo: geração de conteúdo, análise de dados ou suporte ao cliente. Você pode adicionar múltiplas finalidades.',
    },
  },
  {
    element: '#' + AI_INVENTORY_FORM_DRIVER_STEP_5,
    popover: {
      title: 'Etapa 3 — Análise de Riscos',
      description:
        'Avalie se a IA <strong>processa dados pessoais</strong> e identifique os fatores de risco envolvidos. Com base nas respostas, o sistema calculará automaticamente o <strong>nível de risco</strong> (baixo, médio ou alto).',
    },
  },
  {
    element: '#' + AI_INVENTORY_FORM_DRIVER_STEP_6,
    popover: {
      title: 'Etapa 4 — Resumo',
      description:
        'Revise todas as informações cadastradas antes de concluir. Você pode <strong>voltar a qualquer etapa</strong> para corrigir algo.',
    },
  },
  {
    element: '#' + AI_INVENTORY_FORM_DRIVER_STEP_7,
    popover: {
      title: 'Navegação',
      description:
        'Use os botões <strong>Voltar</strong> e <strong>Avançar</strong> para navegar entre as etapas. Ao avançar da primeira etapa, o registro é <strong>salvo automaticamente</strong>.',
    },
  },
]

const AI_INVENTORY_MAIN_DRIVER_STEP_1 = 'ai-inventory-main-step-1'
const AI_INVENTORY_MAIN_DRIVER_STEP_2 = 'ai-inventory-main-step-2'
const AI_INVENTORY_MAIN_DRIVER_STEP_3 = 'ai-inventory-main-step-3'
const AI_INVENTORY_MAIN_DRIVER_STEP_4 = 'ai-inventory-main-step-4'

const AI_INVENTORY_MAIN_DRIVER_STEPS = [
  {
    element: '#' + AI_INVENTORY_MAIN_DRIVER_STEP_1,
    popover: {
      title: 'Inventário de IA',
      description:
        'Nesta tela você gerencia todas as Inteligências Artificiais cadastradas na empresa. Use este tutorial sempre que precisar relembrar como utilizar a tela.',
    },
  },
  {
    element: '#' + AI_INVENTORY_MAIN_DRIVER_STEP_2,
    popover: {
      title: 'Novo Inventário',
      description:
        'Clique aqui para cadastrar uma nova Inteligência Artificial utilizada pela empresa. Você poderá escolher entre o <strong>cadastro guiado pela DAI</strong> — mais rápido e simples — ou o <strong>cadastro manual</strong>, preenchendo você mesmo cada etapa.',
    },
  },
  {
    element: '#' + AI_INVENTORY_MAIN_DRIVER_STEP_3,
    popover: {
      title: 'Filtros',
      description:
        'Utilize os filtros para localizar inventários por nome, nível de risco ou departamento.',
    },
  },
  {
    element: '#' + AI_INVENTORY_MAIN_DRIVER_STEP_4,
    popover: {
      title: 'Lista de inventários',
      description:
        'Aqui estão listados todos os inventários de IA cadastrados. Use o menu de ações para visualizar, editar ou excluir cada registro.',
    },
  },
]

const FORM_STEPS = [
  'Informações Gerais',
  'Finalidade',
  'Análise de Riscos',
  'Resumo',
]

const PURPOSES_STEP = 1

const STEPS_WITH_SUBMIT = new Set([0, 1])

const STEP_FIELDS = [
  ['selectedTool', 'toolName', 'providerName', 'department'],
  ['operationMode', 'humanIntervention'],
  ['processesPersonalData'],
  [],
]

const OPERATION_MODE_OPTIONS = [
  { value: 'assisted', label: 'Assistida' },
  { value: 'automated', label: 'Automatizada' },
  { value: 'autonomous', label: 'Autônoma' },
  { value: 'hybrid', label: 'Híbrida' },
]

const OPERATION_MODE_LABELS = OPERATION_MODE_OPTIONS.reduce(
  (accumulator, option) => ({ ...accumulator, [option.value]: option.label }),
  {},
)

const HUMAN_INTERVENTION_OPTIONS = [
  { value: 'true', label: 'Sim' },
  { value: 'false', label: 'Não' },
]

const RISK_CLASS = { low: 'chipLow', medium: 'chipMedium', high: 'chipHigh' }

const ALERT_CLASS = {
  low: 'alertLow',
  medium: 'alertMedium',
  high: 'alertHigh',
}

const ALERT_ICON = {
  low: AlertCircleIcon,
  medium: AlertTriangleIcon,
  high: AlertOctagonIcon,
}

const CATEGORY_CHIP_CLASS = {
  text_generation: 'chipTextGeneration',
  code_assistant: 'chipCodeAssistant',
  agent: 'chipAgent',
  image_generation: 'chipImageGeneration',
  voice: 'chipVoice',
  video_generation: 'chipVideoGeneration',
  data_analysis: 'chipDataAnalysis',
  search: 'chipSearch',
  translation: 'chipTranslation',
  productivity: 'chipProductivity',
  multimodal: 'chipMultimodal',
}

const NONE_OF_THE_ABOVE_LABEL = 'Nenhum dos anteriores'
const NONE_OPTION_ID = 'FRONTEND_NONE'
const NONE_OPTION = { id: NONE_OPTION_ID, label: NONE_OF_THE_ABOVE_LABEL }

export default {
  AI_INVENTORY_FORM_DRIVER_STEP_1,
  AI_INVENTORY_FORM_DRIVER_STEP_2,
  AI_INVENTORY_FORM_DRIVER_STEP_3,
  AI_INVENTORY_FORM_DRIVER_STEP_4,
  AI_INVENTORY_FORM_DRIVER_STEP_5,
  AI_INVENTORY_FORM_DRIVER_STEP_6,
  AI_INVENTORY_FORM_DRIVER_STEP_7,
  AI_INVENTORY_FORM_DRIVER_STEPS,
  AI_INVENTORY_MAIN_DRIVER_STEP_1,
  AI_INVENTORY_MAIN_DRIVER_STEP_2,
  AI_INVENTORY_MAIN_DRIVER_STEP_3,
  AI_INVENTORY_MAIN_DRIVER_STEP_4,
  AI_INVENTORY_MAIN_DRIVER_STEPS,
  RISK,
  RISK_OPTIONS,
  RISK_CHIP_COLORS,
  RISK_ALERTS,
  FORM_STEPS,
  PURPOSES_STEP,
  STEPS_WITH_SUBMIT,
  STEP_FIELDS,
  OPERATION_MODE_OPTIONS,
  OPERATION_MODE_LABELS,
  HUMAN_INTERVENTION_OPTIONS,
  RISK_CLASS,
  ALERT_CLASS,
  ALERT_ICON,
  CATEGORY_CHIP_CLASS,
  NONE_OF_THE_ABOVE_LABEL,
  NONE_OPTION_ID,
  NONE_OPTION,
}
